import {
    createAction,
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";
import axios from "axios";
import { instance, pathname } from "./ActionCreators";
import notifyError from "../../utils/Notifications/Error";
export type ErrorFlagItem = {
    Name: string;
    "Error Flag": number;
};
export type CloseValueItem = {
    Name: string;
    Close: boolean;
};
export type ITable = {
    id: number;
    columns: string;
    all_columns: [];
    params: Array<object>;
    names: string[];
    error_flags: ErrorFlagItem[];
    close_values: CloseValueItem[];
};

export interface IPage {
    id: number;
    name: string;
    grid: string;
    tables: Array<ITable>;
    sections: ISection[];
    is_pinned: boolean;
}

export interface ISection {
    id: number;
    filter: ISectionFilter;
    name: string | null;
    columns: string[];
    columns_widths: Record<string, number | null>;
    width: number;
    height: number;
    is_collapsed: boolean;
    is_name_pinned: boolean;
    row_density: string;
    font_scale: string;
    color_filter: number[];
}

export interface ISectionFilter {
    query: string;
    names: string[];
}

interface IState {
    loading: boolean;
    error: string | null;
    pages: Array<IPage>;
    activePage: IPage | null;
    highlightedTicker: any;
    loadingTrigger: boolean;
}

const initialState: IState = {
    loading: false,
    error: null,
    pages: [],
    activePage: null,
    highlightedTicker: null,
    loadingTrigger: false,
};

export const getTabs = createAsyncThunk(
    "get/tabs",
    async (_, { rejectWithValue }) => {
        try {
            const response = await instance.get(pathname + "/api/tab");
            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                notifyError(
                    Object.values(e.response?.data || {})
                        .flat()
                        .join(" ") ||
                        e.message ||
                        "Произошла ошибка",
                );

                return rejectWithValue(e.message);
            }
        }
    },
);
export const highlightTicker = createAction<string>("quotes/highlightTicker");

export const getAreasByTabId = createAsyncThunk(
    "get/areas",
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await instance.get(
                pathname + `/api/workspaces/${id}`,
            );
            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                notifyError(
                    Object.values(e.response?.data || {})
                        .flat()
                        .join(" ") ||
                        e.message ||
                        "Произошла ошибка",
                );

                return rejectWithValue(e.message);
            }
        }
    },
);

export const updateTab = createAsyncThunk(
    "update/tab",
    async (data: object, { rejectWithValue, dispatch, getState }) => {
        // console.log('updateTab',getState());

        try {
            //@ts-ignore
            const page = getState().quotesPage.activePage;

            const obj = {
                ...data,
                name: page.name,
                // statuses:getState().tabs.workspaces[0].statuses
            };

            const response = await instance.patch(
                pathname + `/api/tab/${page.id}`,
                obj,
            );

            //dispatch(getTabById(page.id))
            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                notifyError(
                    Object.values(e.response?.data || {})
                        .flat()
                        .join(" ") ||
                        e.message ||
                        "Произошла ошибка",
                );

                return rejectWithValue(e.message);
            }
        }
    },
);

export const updateWorkspace = createAsyncThunk(
    "fix/workspace",
    async (
        { data, tabId }: { data: object; tabId?: number },
        { rejectWithValue, dispatch, getState },
    ) => {
        try {
            //@ts-ignore
            const page = getState().quotesPage.activePage;
            const response = await instance.patch(
                pathname + `/api/workspace_config/${tabId || page.id}`,
                data,
            );

            dispatch(getAreasByTabId(page.id));
            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                notifyError(
                    Object.values(e.response?.data || {})
                        .flat()
                        .join(" ") ||
                        e.message ||
                        "Произошла ошибка",
                );

                return rejectWithValue(e.message);
            }
        }
    },
);

export const updateBulkWorkspace = createAsyncThunk(
    "fix/workspace_bulk",
    async (
        { data, tabId }: { data: object; tabId?: number },
        { rejectWithValue, dispatch, getState },
    ) => {
        try {
            //@ts-ignore
            const page = getState().quotesPage.activePage;
            const response = await instance.patch(
                pathname +
                    `/api/workspace_config/bulk_update/${tabId || page.id}`,
                data,
            );

            return response.data;
        } catch (e) {
            if (axios.isAxiosError(e)) {
                notifyError(
                    Object.values(e.response?.data || {})
                        .flat()
                        .join(" ") ||
                        e.message ||
                        "Произошла ошибка",
                );

                return rejectWithValue(e.message);
            }
        }
    },
);

const quotesPageSlice = createSlice({
    name: "quotesPageSlice",
    initialState,
    reducers: {
        resetQuotesPageState: () => {
            return initialState;
        },
        setHighlightedTicker: (state, action) => {
            state.highlightedTicker = action.payload;
        },
        setActivePage: (state, action: PayloadAction<number | null>) => {
            const page = {
                ...state.pages.find((item) => item.id === action.payload),
            };
            //@ts-ignore
            // state.activePage = page ?? null
            if (page?.id) {
                //@ts-ignore
                state.activePage = page;
            } else if (action.payload === null) {
                state.activePage = null;
            }
        },
        setActivePageName: (state, action: PayloadAction<string>) => {
            if (state.activePage) {
                // console.log(state.activePage,action.payload)
                state.activePage.name = action.payload;
            }
        },

        reorder: (
            state,
            action: PayloadAction<{ source: number; destination: number }>,
        ) => {
            if (!state.activePage) return;
            const { source, destination } = action.payload;
            const [removed] = state.activePage.tables.splice(source, 1);
            state.activePage.tables.splice(destination, 0, removed);
        },

        triggerLoading: (state) => {
            state.loadingTrigger = true;
        },

        setLoadingTrigger: (state, action) => {
            state.loadingTrigger = action.payload;
        },
    },
    extraReducers: {
        [getTabs.fulfilled.type]: (state, action) => {
            state.loading = false;
            state.error = null;
            state.pages = action.payload?.map((item: any) => ({
                ...item,
                tables: [],
            }));
        },
        [getTabs.pending.type]: (state) => {
            state.loading = true;
        },
        [getTabs.rejected.type]: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    setLoadingTrigger,
    triggerLoading,
    setActivePage,
    setActivePageName,
    reorder,
    resetQuotesPageState,
} = quotesPageSlice.actions;

export default quotesPageSlice.reducer;
